export enum MeiliIndex {
  tracks = 'tracks',
  artists = 'artists',
  playlists = 'playlists',
}

export type MeiliTrackData = {
  id: string;
  name: string;
  artistName: string;
  albumName?: string;
  imageUrl?: string;
  isrc?: string;
  duration?: number;
  previewUrl?: string;
  url?: string;
};

export type MeiliArtistData = {
  id: string;
  name: string;
  imageUrl?: string;
  followers?: number;
  url?: string;
  genres?: string[];
};

export type MeiliPlaylistData = {
  id: string;
  name: string;
  curatorName?: string;
  description?: string;
  imageUrl?: string;
  followersCount?: number;
  songsCount?: number;
  integrationType: string;
};

export type SearchDatabaseResultItemTrack = {
  type: MeiliIndex.tracks;
  item: MeiliTrackData;
};

export type SearchDatabaseResultItemArtist = {
  type: MeiliIndex.artists;
  item: MeiliArtistData;
};

export type SearchDatabaseResultItemPlaylist = {
  type: MeiliIndex.playlists;
  item: MeiliPlaylistData;
};

export type SearchDatabaseResultItem =
  | SearchDatabaseResultItemTrack
  | SearchDatabaseResultItemArtist
  | SearchDatabaseResultItemPlaylist;

export type SearchDatabaseResult = {
  type: MeiliIndex;
  items: SearchDatabaseResultItem[];
};

export type SearchItem = {
  title: string;
  subtitle?: string;
  placeholderIcon: string;
  id: string;
  url?: string;
  image?: string;
  isImageRound?: boolean;
  isImagePadding?: boolean;
};
